import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTicketAlt, faLock } from '@fortawesome/free-solid-svg-icons';
import { LinkContainer } from 'react-router-bootstrap';
import { getCurrencyValue, getTicketsTotal, getFeeTotal, getCartTotal, getSubtotal, getPromoCodeDiscount, getFinalTotal, renderPrice } from '../../libs/cartLib';
import LoaderButton from '../../components/common/LoaderButton';
import PromoCodeInput from './PromoCodeInput';

export default function CartSummaryCard({ cart, getTotalItems, mode = 'readonly', onPay, onModify, isLoading }) {
  const [localCart, setLocalCart] = useState(cart);

  // Update local cart when prop changes
  useEffect(() => {
    setLocalCart(cart);
  }, [cart]);

  const ticketsTotal = getTicketsTotal(localCart);
  const feeTotal = getFeeTotal(localCart);
  const subtotal = ticketsTotal + feeTotal;
  const promoCodeDiscount = getPromoCodeDiscount(localCart);
  const cartTotal = subtotal - promoCodeDiscount;

  useEffect(() => {
    console.log('isLoading', isLoading);
  }, [isLoading]);

  const handlePromoCodeApplied = (updatedCart) => {
    setLocalCart(updatedCart);
  };

  const handlePromoCodeRemoved = (updatedCart) => {
    setLocalCart(updatedCart);
  };

  return (
    <div className="cart-summary-box cart-summary-box-card">
      <div className="cart-summary-title">Resumen de compra</div>
      <div className="cart-summary-row">
        <span>Subtotal Boletos</span>
        <span>{renderPrice(localCart, ticketsTotal)}</span>
      </div>
      <div className="cart-summary-row">
        <span>Cargo por servicio de boletería</span>
        <span>+ {renderPrice(localCart, feeTotal)}</span>
      </div>
      
      {promoCodeDiscount > 0 && (
        <div className="cart-summary-row cart-summary-discount">
          <span>Descuento promocional</span>
          <span>- {renderPrice(localCart, promoCodeDiscount)}</span>
        </div>
      )}
      
      <div className="cart-summary-divider"></div>
      <div className="cart-summary-row cart-summary-total-row">
        <span className="cart-summary-total-label">TOTAL</span>
        <span className="cart-summary-total-value">{renderPrice(localCart, cartTotal)}</span>
      </div>
              {mode === 'checkout' && (
        <>
          
          <LinkContainer to="/cart/checkout">
            <button className="btn-theme-primary" disabled={getTotalItems(localCart) === 0}>
              <FontAwesomeIcon icon={faTicketAlt} /> Finalizar la Compra
            </button>
          </LinkContainer>

          <PromoCodeInput
            cart={localCart}
            onPromoCodeApplied={handlePromoCodeApplied}
            onPromoCodeRemoved={handlePromoCodeRemoved}
          />
          {/* <div className="cart-summary-payment-label">Métodos de pago aceptados:</div>
          <div className="cart-summary-payment-icons">
            <span className="cart-payment-icon"></span>
            <span className="cart-payment-icon"></span>
            <span className="cart-payment-icon"></span>
          </div> */}
        </>
      )}
      {mode === 'payment' && (
        <>
          <LoaderButton
            className="btn-theme-primary"
            style={{ marginBottom: 16 }}
            onClick={onPay}
            disabled={!onPay}
            isLoading={isLoading}
          >
            <FontAwesomeIcon icon={faLock} /> Pagar
          </LoaderButton>
          <button
            className="btn-theme-secondary"
            onClick={onModify}
          >
            Modificar orden
          </button>
        </>
      )}
    </div>
  );
} 